import { render, staticRenderFns } from "./clinicsEdit.vue?vue&type=template&id=4bb7176a&"
import script from "./clinicsEdit.vue?vue&type=script&lang=js&"
export * from "./clinicsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports